<!--  -->
<template>
  <div class="tabox">
    <div class="tabselecr_box">
      <div class="selectionArea">
        <div class="item">
          <!-- <span class="title">违规单id</span> -->
          <el-input
            v-model="query.order_id"
            clearable
            style="width:200px;"
            placeholder="请输入违规单id"
          />
        </div>
        <div class="item">
          <!-- <span class="title">账户id</span> -->
          <el-input
            v-model="query.account_id"
            clearable
            style="width:200px;"
            placeholder="账户id(多个账户用,分割)"
          />
        </div>
        <div class="item">
          <!-- <span class="title">上诉状态</span> -->
          <el-select
            v-model="query.appeal_status"
            clearable
            placeholder="请选择上诉状态"
            :style="{ width: '200px' }"
          >
            <el-option
              v-for="item in app_states"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <!-- <span class="title">账户处罚</span> -->
          <el-select
            v-model="query.action_type"
            clearable
            placeholder="请选择账户处罚"
            :style="{ width: '200px' }"
          >
            <el-option
              v-for="item in action_states"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <!-- <span class="title">处理状态</span> -->
          <el-select
            v-model="query.status"
            clearable
            placeholder="请选择处理状态"
            :style="{ width: '200px' }"
          >
            <el-option
              v-for="item in states"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <!-- <span class="title">处罚等级</span> -->
          <el-select
            v-model="query.level"
            clearable
            placeholder="请选择处罚等级"
            :style="{ width: '200px' }"
          >
            <el-option
              v-for="item in stateschufa"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <!-- <span class="item_title">投放组(付费)：</span> -->
          <el-autocomplete
            v-model="displayGroupName"
            :fetch-suggestions="querySearchAsync"
            placeholder="请选择投放组(付费)"
            clearable
            @select="handleGroupSelect"
            @clear="handleClear"
          />
        </div>
        <div class="item">
          <!-- <span class="item_title">投手(付费)：</span> -->
          <el-autocomplete
            v-model="displayPitcherName"
            :fetch-suggestions="queryPitcherSearch"
            placeholder="请选择投手(付费)"
            clearable
            @select="handlePitcherSelect"
            @clear="handlePitcherClear"
          />
        </div>

        <div class="item">
          <!-- <span class="item_title">投放组(免费)：</span> -->
          <el-autocomplete
            v-model="displayGroupNameIaa"
            :fetch-suggestions="queryGroupSearchIaa"
            placeholder="请选择投放组(免费)"
            clearable
            @select="handleGroupSelectIaa"
            @clear="handleGroupClearIaa"
          />
        </div>
        <div class="item">
          <!-- <span class="item_title">投手(免费)：</span> -->
          <el-autocomplete
            v-model="displayPitcherNameIaa"
            :fetch-suggestions="queryPitcherSearchIaa"
            placeholder="请选择投手(免费)"
            clearable
            @select="handlePitcherSelectIaa"
            @clear="handlePitcherClearIaa"
          />
        </div>
        <div class="item">
          <span>违规时间：</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="违规开始日期"
            end-placeholder="违规结束日期"
            :picker-options="{
              disabledDate: (time) => time.getTime() > Date.now()
            }"
            @change="handleDateChange"
          />
        </div>
        <div class="item">
          <span>处罚时间：</span>
          <el-date-picker
            v-model="dateone"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="处罚开始时间"
            end-placeholder="处罚结束时间"
            :picker-options="{
              disabledDate: (time) => time.getTime() > Date.now()
            }"
            @change="handleDateChangeone"
          />
        </div>
        <div class="item">
          <el-button
            type="primary"
            style="margin:0px 10px"
            icon="el-icon-search"
            @click="searchclick"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh-right"
            @click="rechargeclick"
          >重置</el-button>
          <el-button
            type="success"
            icon="el-icon-download"
            @click="exprower"
          >导出</el-button>
        </div>
      </div>
    </div>
    <el-table
      v-loading="listLoading"
      :data="tabledata"
      max-height="750"
      border
    >
      <el-table-column
        prop="order_id"
        width="200"
        label="违规单id"
        align="center"
      />
      <el-table-column
        prop="account_id"
        width="200"
        label="账号id"
        align="center"
      />
      <el-table-column
        prop="company_name"
        width="200"
        label="账户名称"
        align="center"
      />
      <el-table-column
        prop="release_group_name"
        width="200"
        label="投放组"
        align="center"
      />
      <el-table-column
        prop="pitcher_name"
        width="200"
        label="投手"
        align="center"
      />
      <el-table-column
        prop="account_type"
        width="80"
        label="账户类型"
        align="center"
      />
      <el-table-column
        prop="agency_id"
        width="200"
        label="服务商id"
        align="center"
      />
      <el-table-column
        prop="first_industry"
        width="200"
        label="开户行业"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.first_industry }}-{{ scope.row.second_industry }}
        </template>
      </el-table-column>
      <el-table-column
        prop="kpi_first_industry"
        width="200"
        label="KPI行业"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.kpi_first_industry }}-{{ scope.row.kpi_second_industry }}
        </template>
      </el-table-column>
      <el-table-column
        prop="illegal_aid"
        width="200"
        label="违规AID"
        align="center"
      />
      <el-table-column
        prop="illegal_tid"
        width="200"
        label="素材TID"
        align="center"
      />
      <el-table-column
        prop="illegal_dc_id"
        width="200"
        label="DCID"
        align="center"
      />
      <el-table-column
        prop="illegal_component_id"
        width="200"
        label="组件ID"
        align="center"
      />
      <el-table-column
        prop="illegal_time"
        width="200"
        label="违规日期"
        align="center"
      />
      <el-table-column
        prop="new_illegal_obj"
        width="200"
        label="处罚节点/对象"
        align="center"
      />
      <el-table-column
        prop="action_type_text"
        width="200"
        label="账户处罚"
        align="center"
      />
      <el-table-column
        prop="deposit_data"
        width="200"
        label="保证金处罚"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.deposit_data.deduct_id }}</div>
          <div>{{ scope.row.deposit_data.deduct_money }}</div>
          <div>{{ scope.row.deposit_data.punish_money }}</div>
          <div>{{ scope.row.deposit_data.punish_ratio }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="create_time"
        width="200"
        label="处罚时间"
        align="center"
      />
      <el-table-column
        prop="level"
        width="200"
        label="处罚等级"
        align="center"
      />
      <el-table-column
        prop="reason"
        width="200"
        label="处罚原因"
        align="center"
      />
      <el-table-column
        prop="illegal_scene"
        width="200"
        label="处罚场景"
        align="center"
      />
      <el-table-column
        prop="mdm_punish_data"
        width="220"
        label="主体今年违规次数"
        align="center"
      >
        <template slot-scope="scope">
          <div v-for="item,index in scope.row.mdm_punish_data" :key="index">
            {{ item }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="appeal_status_text"
        width="200"
        label="上诉状态"
        align="center"
      />
      <!-- <el-table-column
        prop="status_text"
        width="200"
        label="处理状态"
        align="center"
      /> -->
      <el-table-column
        prop="send_time_text"
        width="150"
        label="操作"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="lookinfo(scope.row)"
          >查看违规凭证</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="违规详情凭证"
      :visible.sync="dialogsendinfo"
      :close-on-click-modal="true"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      width="500px"
      class="custom-dialog"
    >
      <!-- <el-table :data="certificate_list" style="width: 100%">
        <el-table-column width="120">
          <template #default="scope">
            素材{{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row"
              :preview-src-list="[scope.row]"
            />
          </template>
        </el-table-column>

        <el-table-column width="220">
             <template #default="scope">
               <el-button type="success" size="mini" @click="downloadLink(scope.row)">
                   下载
             </el-button>
             </template>
             </el-table-column>
      </el-table> -->
      <div style="max-height:800px; overflow-y:auto;">
        <el-table :data="certificate_list" style="width: 100%">
          <!-- 第一列：显示“素材1”、“素材2”... -->
          <el-table-column width="120">
            <template #default="scope">
              素材{{ scope.$index + 1 }}
            </template>
          </el-table-column>

          <!-- 第二列：显示 URL -->
          <el-table-column>
            <template #default="scope">
              <!-- 判断是否为 m4a 视频 -->
              <template v-if="scope.row.endsWith('.m4a') || scope.row.endsWith('.mp4')">
                <video
                  style="width: 300px; height: 300px"
                  controls
                  :src="scope.row"
                />
              </template>
              <template v-else>
                <el-image
                  style="width: 100px; height: 100px"
                  :src="scope.row"
                  :preview-src-list="[scope.row]"
                  :fit="'cover'"
                />
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>
<script>
import { adManagementList } from '@/api/releaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getReleaseGroupList, getListOfPitchersInTheLaunchGroup } from '@/api/releaseGroup.js'
import { getReleaseGroupListiaa, getListOfPitchersInTheLaunchGroupiaa, accountpunishexport } from '@/api/copyReleaseGroup.js'
export default {
  components: { PaginationRight },
  data() {
    const today = new Date()
    const lastYear = new Date()
    lastYear.setFullYear(today.getFullYear() - 1)

    const formatDate = (date) => {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    }

    const defaultRange = [formatDate(lastYear), formatDate(today)]
    return {
      query: {
        account_id: null,
        order_id: null,
        appeal_status: null,
        status: null,
        action_type: null,
        page: 1,
        page_size: 10,
        release_group_id: '', // 投放组id
        pitcher_id: '', // 投手id
        release_group_id_iaa: '',
        pitcher_id_iaa: '',
        begin_time: defaultRange[0],
        end_time: defaultRange[1],
        create_begin_time: defaultRange[0],
        create_end_time: defaultRange[1]
      },
      displayGroupName: '', // 投放组显示名
      displayPitcherName: '', // 投手显示名
      displayGroupNameIaa: '',
      displayPitcherNameIaa: '',
      listLoading: false,
      tabledata: [],
      sendid: null,
      total: null,
      push_method: null,
      tabledatar: [],
      states: [
        { id: 1, value: '未处理' },
        { id: 2, value: '已处理' }
      ],
      action_states: [
        { id: 2, value: '停封' },
        { id: 3, value: '有期冻结' },
        { id: 4, value: '永久冻结' },
        { id: 6, value: '禁止新建广告' },
        { id: 7, value: '警告' },
        { id: 8, value: '清退' }
      ],
      app_states: [
        { id: 0, value: '未上诉' },
        { id: 1, value: '已上诉' }
      ],
      dialogsendinfo: false,
      certificate_list: [],
      stateschufa: [{ id: 10, value: '一级' },
        { id: 20, value: '二级' }, { id: 30, value: '三级' }, { id: 40, value: '四级' }],
      date: defaultRange,
      dateone: defaultRange
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    async list() {
      this.listLoading = true
      const data = await adManagementList(this.query)
      this.tabledata = data.data.list
      this.total = data.data.total
      this.listLoading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    lookinfo(item) {
      console.log(item.certificate_list)
      this.certificate_list = item.certificate_list
      this.dialogsendinfo = true
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      const today = new Date()
      const lastYear = new Date()
      lastYear.setFullYear(today.getFullYear() - 1)

      const formatDatestr = (date) => {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        return `${y}-${m}-${d}`
      }
      this.query = {
        account_id: null,
        order_id: null,
        appeal_status: null,
        status: null,
        action_type: null,
        page: 1,
        page_size: 10,
        release_group_id: '',
        pitcher_id: '',
        release_group_id_iaa: '',
        pitcher_id_iaa: '',
        level: '',
        begin_time: formatDatestr(lastYear), // 设置 begin_time 为去年的今天
        end_time: formatDatestr(today),
        create_begin_time: formatDatestr(lastYear),
        create_end_time: formatDatestr(today)
      }
      this.date = [formatDatestr(lastYear), formatDatestr(today)]
      this.dateone = [formatDatestr(lastYear), formatDatestr(today)]
      this.displayGroupNameIaa = ''
      this.displayPitcherNameIaa = ''
      this.list()
    },
    async downloadLink(val) {
      console.log(val)
      try {
        const response = await fetch(val)
        const blob = await response.blob()
        const blobUrl = URL.createObjectURL(blob)

        const a = document.createElement('a')
        a.href = blobUrl
        a.download = ``
        a.click()

        setTimeout(() => {
          URL.revokeObjectURL(blobUrl) // 释放内存
        }, 100)
      } catch (error) {
        console.error(`下载失败: ${val}`, error)
      }
    },
    querySearchAsync(queryString, cb) {
    // ⚠️ 搜索时传参要用 name
      getReleaseGroupList({ name: queryString, type: 2 }).then(res => {
        const list = res.data.list.map(item => ({
          value: item.release_group_name, // 展示
          id: item.id // 真实 ID
        }))
        cb(list)
      })
    },
    handleGroupSelect(item) {
      this.query.release_group_id = item.id // 后端字段
      this.displayGroupName = item.value // 展示字段
    },
    handleClear() {
      this.query.release_group_id = ''
      this.displayGroupName = ''
    },
    // ===== 投手相关 =====
    queryPitcherSearch(queryString, cb) {
      if (!this.query.release_group_id) {
        this.$message.warning('请选择投手(付费)')
        return cb([]) // 不返回候选项
      }
      getListOfPitchersInTheLaunchGroup({
        group_id: this.query.release_group_id, // ⚠️ 依赖投放组id
        name: queryString
      }).then(res => {
        console.log('res', res.data.group_user)
        const list = res.data.group_user.map(item => ({
          value: item.nickname,
          pitcher_id: item.bind_id
        }))
        cb(list)
      })
    },
    handlePitcherSelect(item) {
      console.log('666', item)
      this.query.pitcher_id = item.pitcher_id
      this.displayPitcherName = item.value
    },
    handlePitcherClear() {
      this.query.pitcher_id = ''
      this.displayPitcherName = ''
    },

    queryGroupSearchIaa(queryString, cb) {
      getReleaseGroupListiaa({ name: queryString }).then(res => {
        cb(res.data.list.map(item => ({
          value: item.release_group_name,
          leader_id: item.id
        })))
      })
    },
    handleGroupSelectIaa(item) {
      this.query.release_group_id_iaa = item.leader_id
      this.displayGroupNameIaa = item.value
      this.query.pitcher_id_iaa = ''
      this.displayPitcherNameIaa = ''
    },
    handleGroupClearIaa() {
      this.query.release_group_id_iaa = ''
      this.displayGroupNameIaa = ''
      this.query.pitcher_id_iaa = ''
      this.displayPitcherNameIaa = ''
    },
    queryPitcherSearchIaa(queryString, cb) {
      if (!this.query.release_group_id_iaa) {
        this.$message.warning('请选择投手(免费)')
        return cb([])
      }
      getListOfPitchersInTheLaunchGroupiaa({
        group_id: this.query.release_group_id_iaa,
        name: queryString
      }).then(res => {
        cb(res.data.group_user.map(item => ({
          value: item.nickname,
          pitcher_id: item.bind_id
        })))
      })
    },
    handlePitcherSelectIaa(item) {
      this.query.pitcher_id_iaa = item.pitcher_id
      this.displayPitcherNameIaa = item.value
    },
    handlePitcherClearIaa() {
      this.query.pitcher_id_iaa = ''
      this.displayPitcherNameIaa = ''
    },
    handleDateChange(val) {
      // val 是一个数组，如 ["2025-10-01", "2025-10-29"]
      if (val && val.length === 2) {
        this.query.begin_time = val[0]
        this.query.end_time = val[1]
      } else {
        this.query.begin_time = ''
        this.query.end_time = ''
      }
      console.log('当前 query:', this.query)
    },
    handleDateChangeone(val) {
      // val 是一个数组，如 ["2025-10-01", "2025-10-29"]
      if (val && val.length === 2) {
        this.query.create_begin_time = val[0]
        this.query.create_end_time = val[1]
      } else {
        this.query.create_begin_time = ''
        this.query.create_end_time = ''
      }
      console.log('当前 query:', this.query)
    },
    exprower() {
      console.log('111')
      accountpunishexport(this.query).then((res) => {
        this.$message({
          message: '导出成功',
          type: 'success'
        })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tabox {
  padding: 30px;
}
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.titip {
  width: 180px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* 这里是超出几行省略 */
  overflow: hidden;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  /* flex-basis: calc(13% - 10px); */
  margin-right: 10px;
  margin-bottom: 10px;
}
.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}
.custom-dialog .el-dialog__body {
  max-height: 200px; /* 限制内容区最高 200px */
  overflow-y: auto;  /* 超出显示滚动条 */
}
</style>
